import { render } from "./PersonalGrowth.vue?vue&type=template&id=641339d1"
import script from "./PersonalGrowth.vue?vue&type=script&lang=js"
export * from "./PersonalGrowth.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__